import { FunctionComponent } from 'react';

import Title from '../Title';

import { Props } from './index';
import StyledComponent from './styles';

const PublicPageJobSectionJobBlocksJobHeader: FunctionComponent<Props> = ({
    history,
    title,
}) => {
    return (
        <StyledComponent className="public-page-company-site-section-company-block-history">
            <Title title={title} />
            <div className="history">
                {Array.isArray(history) && history.map(({ id, description: historyDesc }) => (
                    <div
                        key={id}
                        className="history-box"
                    >
                        <header className="history-header">
                            <p>{historyDesc.title}</p>
                        </header>
                        <p className="history-content">
                            {historyDesc.description}
                        </p>
                    </div>
                ))}
            </div>
        </StyledComponent>
    );
};

export default PublicPageJobSectionJobBlocksJobHeader;
